"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeConfig = exports.config = void 0;
exports.config = {
    platform: 'web',
    screenWidth: undefined,
};
const mergeConfig = ({ platform, screenWidth }) => {
    const mobileDevices = ['android', 'ios'];
    const platforms = [...mobileDevices, 'back-office', 'web'];
    if (platform === undefined) {
        throw new Error(`"platform" property is required`);
    }
    if (!platforms.includes(platform)) {
        throw new Error(`Expected to find one of the following platforms: ${platforms.join(', ')}`);
    }
    if (mobileDevices.includes(platform) && screenWidth === undefined) {
        throw new Error(`Screenwidth is required when on a mobile device`);
    }
    if (screenWidth !== undefined && screenWidth < 0) {
        throw new Error(`Screenwidth cannot be negative`);
    }
    exports.config.platform = platform;
    exports.config.screenWidth = screenWidth;
};
exports.mergeConfig = mergeConfig;
